export default {
  title: "Добавить выставку",
  eventNameInputPlaceholder: "Название выставки",
  subjectInputPlaceholder: "Тематика выставки",
  datepickerPlaceholder: "Даты проведения"
};
